import { Button, usePropsResolution } from 'native-base';
import React from 'react';
import type { ISegmentedControllerProps } from './SegmentedController.types';

const SegmentedController: React.FunctionComponent<ISegmentedControllerProps> =
  ({ activeSegment, isDisabled, segments, onChange, ...props }) => {
    const { _buttonActive, _buttonInactive, ...resolvedProps } =
      usePropsResolution('SegmentedController', { ...props });

    return (
      <Button.Group isDisabled={isDisabled} {...resolvedProps}>
        {segments.map(({ identifier, ...segment }) => (
          <Button
            {...segment}
            {...(activeSegment === identifier
              ? _buttonActive
              : _buttonInactive)}
            key={identifier}
            onPress={() => onChange(identifier)}
            variant={activeSegment === identifier ? 'solid' : 'ghost'}
          >
            {segment.children}
          </Button>
        ))}
      </Button.Group>
    );
  };

export default SegmentedController;
